import { render, staticRenderFns } from "./TextPitch.vue?vue&type=template&id=5920b9a6"
import script from "./TextPitch.vue?vue&type=script&lang=js"
export * from "./TextPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports